import { ComponentProps } from 'react';
import { compose, mapProps } from 'recompose';
import Errors from 'components/Error';
import withAnalyticsPageView from 'data/tracking/withAnalyticsPageView';
import withErrorPageView from 'data/tracking/withErrorPageView';
import { withPlan, WithPlanProps } from 'data/plan/withPlan';
import buildUrl from 'lib/url';
import { ApiError } from 'lib/error';

type JoinOwnPlanProps = WithPlanProps & {
  error: ApiError;
};

export default compose<
  ComponentProps<typeof Errors.JoinOwnPlan>,
  JoinOwnPlanProps
>(
  withPlan,
  mapProps((props: JoinOwnPlanProps) => ({
    error: props.error,
    theme: props.themes.light,
    planType: props.planType,
    inviteLink: buildUrl(props, 'INVITE'),
  })),
  withAnalyticsPageView('/error/join_own_plan/'),
  withErrorPageView('join_own_plan'),
)(Errors.JoinOwnPlan);
